import api from './api';

export const getQR = () => api.get('/whatsapp/qr');
export const sendMessageApi = data => api.post('/whatsapp/send');
